// extracted by mini-css-extract-plugin
export var container = "_dm-0";
export var segment = "_dm-2";
export var segmentActive = "_dm-3";
export var track = "_dm-1";